import React, { useRef, useState, useEffect, Suspense } from 'react';
import { USBGrid, USBColumn } from '@usb-shield/components-react';
import TopMenu from '../../molecules/TopMenu';
import NavMenu from '../../molecules/NavMenu/NavMenu';
import { endpoints } from '../../../../config/connections';
import './globalheader.css';
import AppLoader from '@usb-ui-tools/micro-app-loader/dist/cjs/index.js';
import useUserRole from '../../Hooks/use-UserRole'


const GlobalHeader = ({
  currentToken,
  onIdleTimeoutLogoutSuccess,
  extendSessionSuccess,
  onIdleTimeoutLogoutFailure,
  refreshTimeCount,
  onSuccessChallenge,
}) => {
  const [isIdle, setIsIdle] = useState(true);
  const [iFrameIdleTime, setiFrameIdleTime] = useState(null);
  const [extendRequest, setextendRequest] = useState(null);
  const [logoutClick, setlogoutClick] = useState(false);

  // history removed; useNavigate in routed components when needed

  const ref = useRef('idleTimeout');
  const userCheck = useUserRole();

  const onLogout = () => {
    sessionStorage.removeItem("remote_user")
    sessionStorage.removeItem("portfolioFilters")
    if (userCheck !== 'employee') {
      setlogoutClick(true);
      const userDataTmp=JSON.parse(sessionStorage.getItem('userData'));
      sessionStorage.clear();
      sessionStorage.setItem("userData",JSON.stringify(userDataTmp));
      window.location.href = '/';
      // sessionStorage.clear();
    } else {
      const userDataTmp=JSON.parse(sessionStorage.getItem('userData'));
      sessionStorage.clear();
      sessionStorage.setItem("userData",JSON.stringify(userDataTmp));
      window.location.href = '/EmployeeRedirect?tp=lg';  
    }
  };

  const configSettings = {
    transmitConfigs: {
      URL: endpoints.transmit,
      APP_ID: 'cdc_web',
      policyIds: {
        EXTEND_USER_SESSION: 'extend_user_session',
        USER_LOGOUT: 'user_logout',
      },
      policyParams: {
        routingKey: endpoints.authRoutingKey,
        appId: 'CDC',
        tenantId: 'USB',
        channelId: 'web',
        appVersion: '1',
      },
    },
  };

  const manageUserSession = () => {
    if (typeof window !== 'undefined') {
      let element = document.getElementById('manageuser-app');
      if (element) {
        window.addEventListener(
          'message',
          (e) => {
            element = document.getElementById('manageuser-app');
            if (e.data.servicingUserActive) {
              setextendRequest(e.data.servicingUserActive);
            }
            if (e.data.servicingUserIdleTime !== undefined) {
              setiFrameIdleTime(e.data.servicingUserIdleTime);
            }
          },
          false
        );
      }
    }
  };


  useEffect(() => {
    manageUserSession();
  }, []);


  return (
    <>
      <USBGrid addClasses="">
        <USBColumn largeSpan={2} />
        <USBColumn largeSpan={12}>
          {currentToken && (
            <>
            <Suspense fallback={<div>Loading...</div>}>

              <AppLoader
                  elementRef={ref}
                  id="auth-extsession"
                  manifestPath={endpoints.manifestPathTimeout}
                  namespace="USBAuthExtSession"
                  isDomainPrefixedToManifestPath={false}
                  appProps={{
                    configSettings:configSettings,
                    currentToken:currentToken,
                    onTransmitAuthorizationFailure:onIdleTimeoutLogoutFailure,
                    onTransmitAuthorizationSuccess:onSuccessChallenge,
                    timerCount:180000, // ExtendSessionTimer
                    loadIdleModule:isIdle,
                    idleTimer:780000
              }}
            />

              </Suspense>
            </>
          )}
          {/* <TopMenu onLogout={onLogout} /> */}
        </USBColumn>
        <USBColumn largeSpan={2} />
      </USBGrid>
      <NavMenu onLogout={onLogout} />
    </>
  );
};

GlobalHeader.propTypes = {};

export default GlobalHeader;
